var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.navType === 'innerRouter')?_c('router-link',{class:{
    'base-gold-btn': true,
    'gradient-border': _vm.styleType === 'gradient'
  },attrs:{"to":_vm.url}},[_vm._t("default")],2):(_vm.navType === 'zendesk')?_c('a',{class:{
    'base-gold-btn': true,
    'gradient-border': _vm.styleType === 'gradient'
  },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.toggleZendesk(true)}}},[_vm._t("default")],2):_c('a',{staticClass:"demo-btn",attrs:{"href":_vm.url,"target":"_blank"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }